(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
}((function () { 'use strict';

    document.addEventListener('DOMContentLoaded', function () {
        // Fonction pour obtenir les paramètres de l'URL
        function getQueryParameter(param) {
            var urlParams = new URLSearchParams(window.location.search);
            return urlParams.get(param);
        }

        // Obtenir la valeur du paramètre "option"
        var selectedOption = getQueryParameter('option');

        // Si une option est trouvée dans l'URL, on la sélectionne dans le champ "select"
        if (selectedOption) {
            var selectField = document.querySelector('select[name="form_fields[objet_demande]"]');
            if (selectField) {
                selectField.value = selectedOption;
            }
        }
    });

})));
//# sourceMappingURL=hello-elementor-child.min.js.map
